export type WarehouseDetails = {
  estimatedLeadTime: string;
  etaDate: string;
  id: string;
  name: string;
  onOrderQuantity: number;
  price?: number;
  productType: string;
  quantityAvailable: number;
  quantityOnOrder: QuantityOnOrderTO[];
  quantityOnOrderEta: QuantityOnOrderTO[];
  reserveInventoryFlag: boolean;
  warehouseLocation: string;
};

export type QuantityOnOrderTO = {
  date: string;
  dateDisplayString: string;
  leadDays: string;
  quantity: number;
  quantityDisplayString: string;
  unitOfMeasure: string;
  uom: string;
};

export type QuantityOnOrder = {
  date: string;
  quantity: number;
};

export type EtaQuantityOnOrder = {
  eta: string;
  quantity: number;
};

export type Warehouse = {
  location: string | null;
  onOrder: number;
  quantityOnOrder?: QuantityOnOrder[];
  stock: number;
};

export type BrazilPnaCallProps = {
  bundleComponents?: BundleComponents[];
  cnpjNumber?: string;
  extendedSpecs?: ExtendedSpecsData[];
  hasIE?: boolean;
  isBundleItem?: boolean;
  shipToProvince?: string;
  shipToUF?: string;
};

export type ExtendedSpecsData = {
  attributeName: string;
  attributeValue: string;
};
export type BundleComponents = {
  ingramPartNumber?: string;
  kitType?: string;
  quantity?: string;
  vendorCode?: string;
};
export const SAP_COUNTRY_CODES: string[] = [
  'AU',
  'CL',
  'CO',
  'ID',
  'MY',
  'NZ',
  'PE',
  'SG',
];

export const EMEA_COUNTRY_CODES: string[] = [
  'ES',
  'IT',
  'FR',
  'GB',
  'BE',
  'NL',
  'PT',
  'CH',
  'NO',
  'SE',
  'FI',
  'DK',
  'HU',
];

export const EMEA_COUNTRY_CODES_PreOrderETA: string[] = ['ES', 'IT', 'FR'];
